
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireefef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireefef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gKHNl", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $c322e9f2577a7e3b$export$6503ec6e8aabbaf; }, function (v) { return $c322e9f2577a7e3b$export$6503ec6e8aabbaf = v; });
var $c322e9f2577a7e3b$export$6503ec6e8aabbaf;
var $c322e9f2577a7e3b$export$f7ad0328861e2f03;
"use strict";
var $c322e9f2577a7e3b$var$mapping = new Map();
function $c322e9f2577a7e3b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c322e9f2577a7e3b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c322e9f2577a7e3b$var$resolve(id) {
    var resolved = $c322e9f2577a7e3b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c322e9f2577a7e3b$export$6503ec6e8aabbaf = $c322e9f2577a7e3b$var$register;
$c322e9f2577a7e3b$export$f7ad0328861e2f03 = $c322e9f2577a7e3b$var$resolve;

});

var $5a311197b7029687$exports = {};

(parcelRequire("gKHNl")).register(new URL("", import.meta.url).toString(), JSON.parse('["dlQAm","index.64e9de6d.js","kgv3l","Mount-Diablo-Bay-View.1e5928ef.webp","hkHP6","Mission-Dolores-Park.f6b361f6.webp","1vL1P","Alameda-South-Shore-Beach.a682d7f2.webp"]'));

const $5832eb44668bdb9f$var$MY_FACE_CONTAINER = document.getElementById("myface-container");
const $5832eb44668bdb9f$var$MY_FACE = document.getElementById("myface");
let $5832eb44668bdb9f$var$intervalId = -1;
let $5832eb44668bdb9f$var$topRight = false;
let $5832eb44668bdb9f$var$bottomRight = true;
let $5832eb44668bdb9f$var$bottomLeft = false;
let $5832eb44668bdb9f$var$topLeft = false;
function $5832eb44668bdb9f$var$updateBorderRadius() {
    let className = "";
    className += $5832eb44668bdb9f$var$topRight ? "top-right " : "";
    className += $5832eb44668bdb9f$var$bottomRight ? "bottom-right " : "";
    className += $5832eb44668bdb9f$var$bottomLeft ? "bottom-left " : "";
    className += $5832eb44668bdb9f$var$topLeft ? "top-left" : "";
    $5832eb44668bdb9f$var$MY_FACE.className = className;
}
function $5832eb44668bdb9f$var$startLoop() {
    clearInterval($5832eb44668bdb9f$var$intervalId);
    $5832eb44668bdb9f$var$intervalId = setInterval(()=>{
        if ($5832eb44668bdb9f$var$topRight) {
            $5832eb44668bdb9f$var$topRight = false;
            $5832eb44668bdb9f$var$bottomRight = true;
        } else if ($5832eb44668bdb9f$var$bottomRight) {
            $5832eb44668bdb9f$var$bottomRight = false;
            $5832eb44668bdb9f$var$bottomLeft = true;
        } else if ($5832eb44668bdb9f$var$bottomLeft) {
            $5832eb44668bdb9f$var$bottomLeft = false;
            $5832eb44668bdb9f$var$topLeft = true;
        } else {
            // topLeft
            $5832eb44668bdb9f$var$topLeft = false;
            $5832eb44668bdb9f$var$topRight = true;
        }
        $5832eb44668bdb9f$var$updateBorderRadius();
    }, 3219);
}
async function $5832eb44668bdb9f$export$b18aab2d2b6b171() {
    $5832eb44668bdb9f$var$MY_FACE_CONTAINER.addEventListener("mouseout", ()=>$5832eb44668bdb9f$var$startLoop());
    $5832eb44668bdb9f$var$MY_FACE_CONTAINER.addEventListener("mouseup", ()=>$5832eb44668bdb9f$var$startLoop());
    $5832eb44668bdb9f$var$MY_FACE_CONTAINER.addEventListener("mousemove", (e)=>{
        // Pause the border radius loop while mouse is in this element
        clearInterval($5832eb44668bdb9f$var$intervalId);
        /*
    (x0,y0)------+
       |         |
       |  (x,y)  |
       |         |
       +------(x1,y1)
    */ const rect = $5832eb44668bdb9f$var$MY_FACE_CONTAINER.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const x0 = 0;
        const y0 = 0;
        const x1 = rect.width;
        const y1 = rect.height;
        // console.log("x:", x, ", y:", y, ", x0:", x0, ", y0", y0, ", x1:", x1, ", y1:", y1);
        /*
    (x0,y0)---------xHalf------------+
       |   top-left   |  top-right   |
     yHalf----------(x,y)----------yHalf
       | bottom-left  | bottom-right |
       +------------xHalf---------(x1,y1)
    */ const xHalf = x0 + (x0 + x1) / 2;
        const yHalf = y0 + (y0 + y1) / 2;
        $5832eb44668bdb9f$var$topRight = false;
        $5832eb44668bdb9f$var$bottomRight = false;
        $5832eb44668bdb9f$var$bottomLeft = false;
        $5832eb44668bdb9f$var$topLeft = false;
        if (x < xHalf) {
            if (y < yHalf) $5832eb44668bdb9f$var$topLeft = true;
            else $5832eb44668bdb9f$var$bottomLeft = true;
        } else if (y < yHalf) $5832eb44668bdb9f$var$topRight = true;
        else $5832eb44668bdb9f$var$bottomRight = true;
        $5832eb44668bdb9f$var$updateBorderRadius();
    });
    $5832eb44668bdb9f$var$startLoop();
}


var $2b1cd51fc7087004$exports = {};
$2b1cd51fc7087004$exports = new URL("Mount-Diablo-Bay-View.1e5928ef.webp", import.meta.url).toString();


var $f7b06d77415d540b$exports = {};
$f7b06d77415d540b$exports = new URL("Mission-Dolores-Park.f6b361f6.webp", import.meta.url).toString();


var $a7c16101dc716d21$exports = {};
$a7c16101dc716d21$exports = new URL("Alameda-South-Shore-Beach.a682d7f2.webp", import.meta.url).toString();


const $4c7c619664a416e1$var$BACKGROUND_IMAGES = [
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2b1cd51fc7087004$exports))),
        loaded: false
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f7b06d77415d540b$exports))),
        loaded: false
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a7c16101dc716d21$exports))),
        loaded: false
    }
];
const $4c7c619664a416e1$var$BACKGROUND_ELEMENT = document.getElementById("background");
let $4c7c619664a416e1$var$backgroundImage = $4c7c619664a416e1$var$BACKGROUND_IMAGES[0];
let $4c7c619664a416e1$var$numLoaded = 0;
function $4c7c619664a416e1$var$setBackgroundImage(image) {
    $4c7c619664a416e1$var$backgroundImage = image;
    $4c7c619664a416e1$var$BACKGROUND_ELEMENT.style.backgroundImage = `url(${image.src})`;
    $4c7c619664a416e1$var$BACKGROUND_ELEMENT.style.opacity = "1";
}
function $4c7c619664a416e1$var$changeImage() {
    const images = $4c7c619664a416e1$var$BACKGROUND_IMAGES.filter((image)=>image.loaded);
    if (images.length > 1) {
        let index = images.indexOf($4c7c619664a416e1$var$backgroundImage);
        index += 1;
        if (index === images.length) index = 0;
        $4c7c619664a416e1$var$setBackgroundImage(images[index]);
    }
}
function $4c7c619664a416e1$var$startSlideshow(mediaQuery) {
    if (mediaQuery.matches) $4c7c619664a416e1$var$BACKGROUND_IMAGES.forEach((image)=>{
        if (!image.element) {
            const element = new Image();
            element.onload = ()=>{
                image.loaded = true;
                if ($4c7c619664a416e1$var$numLoaded === 0) {
                    $4c7c619664a416e1$var$setBackgroundImage(image);
                    setInterval($4c7c619664a416e1$var$changeImage, 15000);
                }
                $4c7c619664a416e1$var$numLoaded += 1;
            };
            element.src = image.src;
            image.element = element;
        }
    });
}
async function $4c7c619664a416e1$export$17916ffb303dab95() {
    const mediaQuery = window.matchMedia("(min-width: 1000px)");
    $4c7c619664a416e1$var$startSlideshow(mediaQuery);
    mediaQuery.addEventListener("change", $4c7c619664a416e1$var$startSlideshow);
}


const $e6a02e8e5b462043$var$LIKES_COUNTER_URL = "https://api.seankrail.dev/count/likes";
const $e6a02e8e5b462043$var$MAX_LIKES_PER_SESSION = 3;
const $e6a02e8e5b462043$var$LIKES_CONTAINER = document.getElementById("likes-container");
const $e6a02e8e5b462043$var$LIKES_THUMB = document.getElementById("likes-thumb");
const $e6a02e8e5b462043$var$LIKES_COUNT = document.getElementById("likes-count");
let $e6a02e8e5b462043$var$isLikeEnabled = false;
let $e6a02e8e5b462043$var$totalLikes = 0;
let $e6a02e8e5b462043$var$likesThisSession = 0;
function $e6a02e8e5b462043$var$setLikesCount(likes) {
    $e6a02e8e5b462043$var$LIKES_CONTAINER.style.visibility = "visible";
    $e6a02e8e5b462043$var$LIKES_COUNT.innerHTML = `${likes}`;
    $e6a02e8e5b462043$var$LIKES_CONTAINER.style.opacity = "1";
    $e6a02e8e5b462043$var$isLikeEnabled = true;
}
async function $e6a02e8e5b462043$var$getLikes() {
    const response = await window.fetch($e6a02e8e5b462043$var$LIKES_COUNTER_URL, {
        method: "GET"
    });
    $e6a02e8e5b462043$var$totalLikes = Number(await response.text());
    return $e6a02e8e5b462043$var$totalLikes;
}
async function $e6a02e8e5b462043$var$like() {
    if ($e6a02e8e5b462043$var$isLikeEnabled) {
        if ($e6a02e8e5b462043$var$likesThisSession < $e6a02e8e5b462043$var$MAX_LIKES_PER_SESSION) {
            window.fetch($e6a02e8e5b462043$var$LIKES_COUNTER_URL, {
                method: "POST"
            });
            $e6a02e8e5b462043$var$LIKES_THUMB.style.fontVariationSettings = "'FILL' 1";
        }
        $e6a02e8e5b462043$var$likesThisSession += 1;
        $e6a02e8e5b462043$var$totalLikes += 1;
        $e6a02e8e5b462043$var$setLikesCount($e6a02e8e5b462043$var$totalLikes);
    }
}
async function $e6a02e8e5b462043$export$71f7d6ce0daffb8a() {
    $e6a02e8e5b462043$var$setLikesCount(await $e6a02e8e5b462043$var$getLikes());
    $e6a02e8e5b462043$var$LIKES_CONTAINER.addEventListener("click", ()=>$e6a02e8e5b462043$var$like());
}




(async ()=>{
    (0, $4c7c619664a416e1$export$17916ffb303dab95)();
})();
(async ()=>{
    (0, $5832eb44668bdb9f$export$b18aab2d2b6b171)();
})();
(async ()=>{
    (0, $e6a02e8e5b462043$export$71f7d6ce0daffb8a)();
})();


//# sourceMappingURL=index.64e9de6d.js.map
